import _defineProperty from '@babel/runtime/helpers/defineProperty';
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/**
 * Sends a tracking event if analytics is activated.
 * Besides the given information it also adds some basic information like the current page the tracking was executed.
 *
 * Note: Structure/params are defined by marketing wishes:
 * - group either use `formwizard` (default) or `formwizard_additional_steps` for the extended wizard.
 * - label is either the text of element the user clicks on, the keyboard event which proceed the stepper
 *   or "done" in case it submits the data in the end.
 * - step saves the transition between two steps to allow following the path through the dialog.
 *   Start and end have no "variants", so step is not defined in that case.
 * - recruiterId, leadId for campaign tracking (maybe changing in future).
 * - dialogId to track which dialog the user goes through.
 *
 * Note 2: Back-navigation is not tracked as not wished.
 *
 * @param event {string}
 * @param params {object=} - Additional parameter like group, label...
 */
var analyticsTrack = function analyticsTrack(_ref) {
  var _window;
  var event = _ref.event,
    params = _ref.params;
  return (_window = window) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 ? void 0 : _window.track(event, _objectSpread({
    path: window.location.pathname,
    pathOrigin: window.location.origin,
    group: 'formwizard'
  }, params));
};
export { analyticsTrack as default };